import React from 'react';
import PropTypes from 'prop-types';
import { SelectField } from 'admin-components/components';
import { intlShape } from 'react-intl';
import { getStationOptions } from './StationSelectField.utils';

const StationSelectField = ({ label, key, name, id, className, disabled, value, stations, onChange, intl: { formatMessage }, width }) => (
  <SelectField
    className={className}
    label={label}
    key={key}
    required
    disabled={disabled}
    width={width || '100%'}
    name={name}
    id={id}
    async
    openMenu={(val) => val.length > 2}
    focusOnNextField
    hideIndicators
    value={value}
    noOptionsMessage={formatMessage({
      id: 'bookingMagnet.noStationsFound'
    })}
    loadOptions={(textValue) =>
      Promise.resolve(
        getStationOptions(stations, textValue).map((station) => ({
          label: `${station.name} - ${station.shortCode}`,
          value: station.uic
        }))
      )
    }
    options={stations.map((station) => ({
      label: `${station.name} - ${station.shortCode}`,
      value: station.uic
    }))}
    onChange={onChange}
  />
);

StationSelectField.propTypes = {
  label: PropTypes.node,
  key: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  stations: PropTypes.arrayOf(
    PropTypes.shape({
      uic: PropTypes.string,
      shortCode: PropTypes.string,
      name: PropTypes.string,
      searchStrings: PropTypes.arrayOf(PropTypes.string)
    })
  ),
  onChange: PropTypes.func,
  width: PropTypes.string,
  intl: intlShape
};

export default StationSelectField;
